export default __webpack_public_path__ + "media/images/Masto-I1-Masto-mammouth-51959db30a59020c8cd4eeceed109dc6.png";